import axios from 'axios';
import { stringify } from 'qs';

import { handleConvertToApi, handleConvertFromApi } from 'helpers/apiHelper';
const client = axios.create({
  paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' }),
});

client.interceptors.response.use((originalResponse) => {
  handleConvertFromApi(originalResponse.data);
  return originalResponse;
});

client.interceptors.request.use((originalRequest) => {
  handleConvertToApi(originalRequest.data);
  return originalRequest;
});

export default client;
